// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"explore-off"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13.6992 9.07L15.7016 8.29987L14.9314 10.3022M7.88379 2.88376C9.13915 2.31604 10.5327 2 12 2C17.5229 2 22 6.47715 22 12C22 13.4673 21.684 14.8609 21.1163 16.1162M4.92893 4.92896C3.11929 6.7386 2 9.2386 2 12C2 17.5229 6.47715 22 12 22C14.7614 22 17.2614 20.8807 19.0711 19.0711M12.5089 16.6013L11.1581 12.8436L7.40039 11.4928L10.3577 10.3554L13.6463 13.644L12.5089 16.6013Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 3L21 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-explore-off')
export default class ExploreOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'explore-off',
    }
  }
}
